module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="useFiltersBnr__arrow"></div>\r\n<div class="useFiltersBnr__icon"></div>\r\n<div class="useFiltersBnr__descriptions">\r\n	<div class="useFiltersBnr__title">Воспользуйтесь фильтрами</div>\r\n	<div>Так вам будет проще найти подходящий тур и комфортный отель</div>\r\n</div>';
}
return __p;
};
